import React from 'react';
import '../global.css'; // Adjust path if needed

const StyleGuide = () => {
  return (
    <div className="container">
      <h1>🎨 Style Guide</h1>

      {/* Typography */}
      <section className="card">
        <h2>Typography</h2>
        <h1>Main Heading (h1)</h1>
        <h2>Subheading (h2)</h2>
        <h3>Subsubheading (h3)</h3>
        <p>Body text with default size.</p>
        <p className="text-small">Small text with secondary tone.</p>
        <p className="text-muted">Muted secondary text (e.g., for notes).</p>
      </section>

      {/* Buttons */}
      <section className="card">
        <h2>Buttons</h2>
        <button className="btn-primary">Primary Button</button>
        <button className="btn-secondary" style={{ marginLeft: '1rem' }}>
          Secondary Button
        </button>
      </section>

      {/* Card Example */}
      <section className="card">
        <h2>Card</h2>
        <div className="card">
          <h3>Player Name: Jordan Smith</h3>
          <p>Team: Thunderbolts</p>
          <p>Position: Outside Hitter</p>
        </div>
      </section>

      {/* Progress Bars */}
      <section className="card">
        <h2>Progress Bars</h2>

        <p>Beginner Skill</p>
        <div className="progress-bar-container">
          <div className="progress-fill progress-beginner" style={{ width: '40%' }}></div>
        </div>

        <p className="mt-2">Intermediate Skill</p>
        <div className="progress-bar-container">
          <div className="progress-fill progress-intermediate" style={{ width: '70%' }}></div>
        </div>

        <p className="mt-2">Advanced Skill</p>
        <div className="progress-bar-container">
          <div className="progress-fill progress-advanced" style={{ width: '90%' }}></div>
        </div>
      </section>

      {/* Spacing */}
      <section className="card">
        <h2>Spacing Examples</h2>
        <div className="mb-2">Margin bottom 0.5rem</div>
        <div className="mb-4">Margin bottom 1rem</div>
        <div className="mb-6">Margin bottom 1.5rem</div>
      </section>

      {/* Flex Layout */}
      <section className="card">
        <h2>Flex Layout</h2>
        <div className="flex-row">
          <div className="card" style={{ flex: 1 }}>
            <p>Item 1</p>
          </div>
          <div className="card" style={{ flex: 1 }}>
            <p>Item 2</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default StyleGuide;
